import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'
import IFamily from '../../../backoffice/brands/models/FamilyInterface'

interface FamilyAutocompleteProps {
  value: IFamily | null
  handleInputChange: (inputName: string, value: any) => void
}

export function FamilyAutocomplete({ value, handleInputChange }: FamilyAutocompleteProps) {
  const { t } = useTranslation(['global'])
  const { userFamilies } = useSelector((state: IRootState) => state.brand)

  const handleAutoCompleteChange = (family: IFamily | null) => {
    handleInputChange('family', family)
  }

  return (
    <Autocomplete
      id="autocomplete-families"
      value={value}
      onChange={(_, value) => handleAutoCompleteChange(value)}
      options={userFamilies}
      getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
      renderInput={params => <TextField {...params} label={t('family')} variant="filled" InputLabelProps={{ shrink: true }} />}
    />
  )
}
